import { collection, doc, setDoc } from 'firebase/firestore'
import { Alert } from '../../contexts/ApplicationSuiteProvider'
import { firebase_firestore } from '../firebaseConfig'
import { setNestedAlertSymbol } from './setNestedAlertSymbol'
import { compositeGateActive } from './composite'

/**
 * Writes a brand-new alert to `tradingPlans` and returns the alert exactly as
 * persisted (id assigned, symbol propagated, composite gate applied).
 *
 * Shared by the create and duplicate flows. Callers are responsible for
 * whatever pattern handling their flow needs BEFORE calling this — the create
 * flow copies non-owned patterns into the user's account first, while the
 * duplicate flow deliberately reuses the source's pattern so `autoUpdatePattern`
 * keeps pointing at it.
 */
export async function saveNewAlert(alert: Alert): Promise<Alert> {
  const docRef = doc(collection(firebase_firestore, 'tradingPlans'))
  const alertDataToSave = structuredClone(alert)
  alertDataToSave.id = docRef.id

  // Propagate the chosen symbol through the embedded pattern copy and every
  // nested condition, so the alert evaluates against the right instrument.
  if (alertDataToSave.symbol && alertDataToSave.pattern) {
    setNestedAlertSymbol(alertDataToSave.pattern, alertDataToSave.symbol)
  }

  // Backstop shared by every creation flow: the alert engine cannot evaluate
  // custom (composite) indicators yet, so such an alert must never be born
  // active — the activation toggles are gated too.
  if (alertDataToSave.pattern && compositeGateActive(alertDataToSave.pattern)) {
    alertDataToSave.active = false
  }

  await setDoc(docRef, alertDataToSave)
  return alertDataToSave
}
